<template>
  <v-dialog
    v-model="show"
    max-width="500"
    overlay-color="darktext"
    overlay-opacity="0.6"
  >
    <v-card>
      <v-card-title>
        {{ $t('confirmationDialogTitleEmbedCode') }}
      </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
          @keyup.enter="submitDialogBtn()"
          @submit.prevent
        >
        <v-textarea
            v-model="codeVal"
            data-testid="embedded-code-textarea"
            elevation="6"
            class="rounded-xxl text-body-2"
            auto-grow
            solo
            :placeholder="$t('confirmationDialogInputPlaceholderEmbedCode')"
            :rules="codeRules"
            :error-messages="errors"
          /> 
          <v-card-actions>
            <v-spacer />
            <v-btn
              ref="cancel"
              data-testid="cancel-button"
              color="darktext"
              min-width="100"
              dark
              elevation="0"
              class="rounded-xxl text-none px-4"
              @click="show=false"
            >
              {{ $t('cancel') }}
            </v-btn>
            <v-btn
              ref="submit"
              data-testid="submit-button"
              type="submit"
              color="accent"
              min-width="100"
              dark
              elevation="0"
              class="rounded-xxl text-none px-4"
              :loading="loading"
              @click="submitDialogBtn"
            >
              {{ $t('save') }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { ruleRequired } from '../rules/formRules.js';
import i18n from '../plugins/i18n'

export default {
  props: {
    visible: Boolean,
    code: {
      type: String,
      default: "",
    },
  },
  data(){
        return{
          alertMsg: '',
          valid: true,
          errors: [],
          loading: false,
          val: "",
          codeRules: ruleRequired('labelEmbeddedCode')
         }
    },

  computed: {
    show: {
      get () {
        return this.visible
      },
      set (value) {
        if (!value) {
          this.$emit('close')
          this.$refs.form.reset()
        }
      }
    },
    codeVal:
    {
      get()
      {
        return this.val
      },
      set(code)
      {
        this.val = code
      }
    }
  },
  watch: {
    codeVal(newVal) {
        this.val = newVal
        var content = document.createElement('div');
        content.insertAdjacentHTML('beforeend', newVal.trim());
        if(content.firstChild != null){
          if(newVal == '' || (newVal.trim().startsWith('<iframe') && newVal.trim().endsWith('</iframe>') && content.firstChild.hasAttribute('src'))){
            this.errors = []
          }
        }
    }
  },
  created(){
    if(this.code == ''){
      this.codeVal = this.code
    }else {
      var content = document.createElement('div');
      content.insertAdjacentHTML('beforeend', this.code);
      this.codeVal = content.querySelector('[class*="embedded-code-wrapper"]').innerHTML.replace('tag="embedded-code"', '');
    }
  },
  methods: {
    async submitDialogBtn() {
      this.loading = true
      this.valid = this.$refs.form.validate()
      if(this.valid){
        var content = document.createElement('div');
        content.insertAdjacentHTML('beforeend', this.codeVal.trim());
        if(content.firstChild != null){
          if(this.codeVal.trim().startsWith('<iframe') && this.codeVal.trim().endsWith('</iframe>') && content.firstChild.hasAttribute('src')){
            this.codeVal = this.codeVal.trim().replace('<iframe', '<iframe tag="embedded-code"')
            this.$emit('proceedSubmit', this.codeVal)
          }else{
            this.errors = [i18n.t('embeddedCodeRuleNotValid')]
          }
        }else{
          this.errors = [i18n.t('embeddedCodeRuleNotValid')]
        }
      }
      this.loading = false
    }
  }
}
</script>